import { Button, Flex, Text } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

interface MenuItemProps {
  title: string;
  path: string;
}

export function MenuItem({title, path}: MenuItemProps) {
  const location = useLocation();

  return (
    <Button
      variant={"unstyled"}
      onClick={() => window.location.href = path === "/home" ? "/" : path}
      padding={2}
      bg={location.pathname === "/" && path === '/home' ? '#002d4a' : location.pathname.includes(path) ? '#002d4a' : 'transparent'}
      color={location.pathname === "/" && path === '/home' ? 'white' : location.pathname.includes(path) ? 'white' : '#447fd2'}
      _hover={{ color: "white", bgColor: '#447fd2' }}
    >
      <Flex
        gap={2}
        flexDir="column"
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Text
          textTransform={'capitalize'}
          letterSpacing={"0.6px"}
          lineHeight={"18.2px"}
          fontSize={"lg"}
          fontWeight={"600"}
        >
          {title}
        </Text>
      </Flex>
    </Button>
  );
}
